function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h70v70H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.243 52.263c6.39.76 14.78-4.31 14.864-4.363 8.785-4.432 13.625-3.895 15.298-3.463l-4.478-17.013c-7.771-.734-15.736 4.435-15.816 4.488-8.1 4.193-13.869 4.283-15.658 4.183l5.79 16.168z",
  stroke: "#371447",
  strokeWidth: 1.857,
  fill: "#D360E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.618 41.603l-.291-1.03c-.724.18-1.473.192-1.946.074l-.037-1.364a3.86 3.86 0 001.905-.05c.608-.182.957-.544.834-.978-.116-.411-.531-.57-1.397-.606-1.252-.051-2.184-.361-2.48-1.413-.27-.954.18-1.9 1.257-2.467l-.291-1.03 1.044-.311.27.955c.724-.181 1.247-.172 1.648-.103l.037 1.317c-.31-.037-.872-.14-1.64.089-.693.206-.832.576-.746.88.1.357.539.474 1.543.551 1.398.078 2.079.522 2.354 1.498.273.965-.166 1.989-1.331 2.571l.312 1.106-1.045.311z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.643 26.54c1.618.59 2.78 1.074 3.483 1.452.703.377 1.618 1.008 2.744 1.89M9 34.818c1.724-.026 2.982.012 3.774.114.793.101 1.874.364 3.244.786M21.519 19.667c1.082 1.335 1.826 2.344 2.234 3.028.407.684.865 1.693 1.373 3.027M31.064 16.867c.67 1.58 1.106 2.754 1.308 3.524.202.769.363 1.864.482 3.286M39.378 15c.266 1.694.404 2.94.413 3.734.009.795-.102 1.896-.332 3.305M48.935 15c.117 1.711.144 2.963.084 3.755-.06.793-.268 1.88-.62 3.264M59.15 17.8c-.65 1.589-1.176 2.726-1.58 3.412-.404.686-1.069 1.573-1.996 2.662",
  stroke: "#371447",
  strokeWidth: 1.857
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.643 40.68l.561 2.066c3.689-.935 6.274-1.664 7.754-2.188 2.678-.947 4.862-2.124 6.694-3.045l-.522-1.98c-2.825 1.3-5.084 2.256-6.776 2.869-1.692.613-4.262 1.372-7.711 2.277zM27.571 44.976l.562 2.066c3.688-.934 6.273-1.663 7.754-2.187 2.678-.947 2.099-.821 3.93-1.742l-.521-1.98c-.984.43-2.322.952-4.013 1.565-1.692.614-4.263 1.373-7.712 2.278z",
  fill: "#371447"
}));

function SvgSurpriseSavingsLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSurpriseSavingsLg;